import type { ModuleManifest } from '../types.js'

/*
 * АГУУЛАХ — ачилтын хаалга, захиалгын дараалал, багцлах, бэлтгэл.
 *
 * ! Захиалгыг ХУУЛБАРЛАХГҮЙ. 1С-ийн баримт нь эх сурвалж хэвээр; энэ модуль
 * ! зөвхөн ГҮЙЦЭТГЭЛИЙН төлвийг эзэмшинэ — хаалга, багц, бэлдэгч, батламж
 * ! ([[16-fulfilment-plan]] §Гол шийдвэр).
 *
 * ! `delivery` модулиас ТУСДАА байх шалтгаан: цэс нэг модулиар хүрээлэгддэг
 * ! тул агуулахын ажилтан түгээлтийн цэс харах шаардлагагүй.
 */
export const warehouseModule = {
  key: 'warehouse',
  name: 'Агуулах',
  description: 'Ачилтын хаалга, захиалгын дараалал, багцлах, бэлтгэл.',
  version: '0.1.0',
  icon: 'WarehouseIcon',

  /*
   * ! ШИНЭ суулгацад УНТРААЛТТАЙ. Модуль хөгжүүлэлтийн шатанд байгаа —
   * ! бүрэн болтол нь бодит орчинд цэсэнд гарах ёсгүй.
   */
  enabledByDefault: false,

  permissions: [
    { resource: 'warehouse.gates', action: 'list', description: 'Ачилтын хаалга харах' },

    /*
     * ! `manage` нь ХУВААРИЛАЛТЫГ ч хамарна. Хаалганд ажилтан оноох нь
     * ! мобайл аппын нэвтрэх эрхийг тодорхойлдог (`has_gate_assignment`) —
     * ! тусдаа эрх болговол хэн ажиллаж чадахыг хоёр газраас удирдана.
     */
    { resource: 'warehouse.gates', action: 'manage', description: 'Хаалга үүсгэх, ажилтан хуваарилах' },

    { resource: 'warehouse.orders', action: 'list', description: 'Захиалгын дараалал харах' },
    { resource: 'warehouse.orders', action: 'manage', description: 'Захиалгыг хаалганд хуваарилах' },

    /*
     * ! ТӨЛБӨРИЙН ХОРИГ ЧӨЛӨӨЛӨХ нь тусдаа эрх. Хуваарилах эрхтэй хүн бүр
     * ! төлөөгүй харилцагчийн барааг гаргах эрхтэй байх ёсгүй — энэ нь
     * ! санхүүгийн шийдвэр.
     */
    { resource: 'warehouse.orders', action: 'override-payment', description: 'Төлбөрийн хориг чөлөөлөх' },

    { resource: 'warehouse.batches', action: 'list', description: 'Ачилтын багц харах' },

    /*
     * ! `manage` нь багцлалтыг ГАРААР ажиллуулахыг ч хамарна. Автомат ажил
     * ! гурван цаг тутам явдаг тул гарын дуудлага нь ховор, зориудын үйлдэл.
     */
    { resource: 'warehouse.batches', action: 'manage', description: 'Багц үүсгэх, төлөв ахиулах' },

    { resource: 'warehouse.picking', action: 'list', description: 'Бэлтгэлийн хуудас харах' },
    { resource: 'warehouse.picking', action: 'manage', description: 'Бараа бэлдэх, сери бүртгэх' },

    /*
     * ! НЯРВЫН БАТАЛГАА нь тусдаа эрх. Бэлдэгч өөрийнхөө ажлыг батлах ёсгүй —
     * ! хоёр гарын дүрэм. Нэг эрхэд нийлүүлбэл хяналт утгагүй болно.
     */
    { resource: 'warehouse.picking', action: 'approve', description: 'Бэлдсэн барааг батлах (нярав)' },

    /*
     * ! БУЦААЛТЫН ХҮСЭЛТ ([[44-return-requests]]). `accept` нь 1С-д ОРЛОГО
     * ! үүсгэдэг (хүсэлтийн буцаалтад) — харах эрхээс ТУСДАА. Түгээлтийн
     * ! `delivery.returns:*`-ээс ч тусдаа: цэс модулиар хүрээлэгддэг тул нярав
     * ! түгээлтийн модуль харах шаардлагагүй.
     */
    { resource: 'warehouse.returns', action: 'list', description: 'Буцаалтын хүсэлт харах' },
    {
      resource: 'warehouse.returns',
      action: 'accept',
      description: 'Буцаалтыг засах, баталгаажуулах (1С орлого), татгалзах (нярав)',
    },
  ],

  navigation: [
    {
      label: 'Агуулах',
      items: [
        /* ! САМБАР эхэнд — агуулахын дэлгэц ханан дээр энэ хуудсаар нээгддэг. */
        {
          label: 'Самбар',
          href: '/warehouse/dashboard',
          icon: 'LayoutDashboardIcon',
          iconClassName: 'text-primary',
          permission: 'warehouse.orders:list',
        },
        {
          label: 'Ачилтын хаалга',
          href: '/warehouse/gates',
          icon: 'DoorOpenIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'warehouse.gates:list',
        },
        {
          /*
           * ! ТҮР ЦАГИЙН АЖИЛТАН — ачигч, туслах. ХН-ийн бүртгэлд ОРДОГГҮЙ нь
           * ! зориуд: өдрөөр ажилладаг, гэрээ ба цалингийн бүртгэл үүсгэдэггүй.
           * ! Эрх нь ХААЛГАНЫХ — хаалга удирддаг хүн ачигчаа өөрөө бүртгэнэ,
           * ! HR-т өдөр бүр хандахгүй.
           */
          label: 'Түр цагийн ажилтан',
          href: '/warehouse/casual-workers',
          icon: 'HardHatIcon',
          iconClassName: 'text-orange-600 dark:text-orange-400',
          permission: 'warehouse.gates:list',
        },
        {
          label: 'Захиалгын дараалал',
          href: '/warehouse/orders',
          icon: 'PackageIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'warehouse.orders:list',
        },
        {
          label: 'Бэлтгэл',
          href: '/warehouse/picking',
          icon: 'ClipboardCheckIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'warehouse.picking:list',
        },
        {
          label: 'Ачилтын багц',
          href: '/warehouse/batches',
          icon: 'LayersIcon',
          iconClassName: 'text-violet-600 dark:text-violet-400',
          permission: 'warehouse.batches:list',
        },
        {
          /*
           * ! ГУРВАН ТӨРӨЛ НЭГ ДАРААЛАЛД: хаалганы, борлуулагчийн хүсэлтийн,
           * ! гар бүртгэлийн буцаалт. Нярав бараа·харилцагч·серийг тулгаж
           * ! баталгаажуулна ([[44-return-requests]]).
           */
          label: 'Буцаалтын хүсэлт',
          href: '/warehouse/returns',
          icon: 'Undo2Icon',
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'warehouse.returns:list',
        },
      ],
    },
  ],

  resources: [
    { name: 'warehouse.dashboard', label: 'Агуулахын самбар', list: '/warehouse/dashboard', canDelete: false },
    {
      name: 'warehouse.gates',
      label: 'Ачилтын хаалга',
      list: '/warehouse/gates',
      canDelete: true,
    },
    {
      name: 'warehouse.orders',
      label: 'Захиалгын дараалал',
      list: '/warehouse/orders',
      canDelete: false,
    },
    {
      name: 'warehouse.picking',
      label: 'Бэлтгэл',
      list: '/warehouse/picking',
      show: '/warehouse/picking/:id',
      canDelete: false,
    },
    {
      name: 'warehouse.batches',
      label: 'Ачилтын багц',
      list: '/warehouse/batches',
      show: '/warehouse/batches/:id',
      canDelete: false,
    },
    {
      name: 'warehouse.returns',
      label: 'Буцаалтын хүсэлт',
      list: '/warehouse/returns',
      show: '/warehouse/returns/:id',
      canDelete: false,
    },
  ],
} as const satisfies ModuleManifest
